export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-social-tumblr-4f12a28f6b318be1d66e80bd70e09477.svg";